/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
import BaseFeature from '../../foundation/base/base';
import '../../foundation/utilities/polyfills';
import '../../foundation/utilities/pxToRem';
import pxToRem from '../../foundation/utilities/pxToRem';

export class ClusternavMobile extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.clusterLinkArrow = this.el.querySelector('.js-isopen li a span');
		this.offCanvasPlate = document.querySelector('[data-ref="off-canvas__plate"]')
		this.slideValue = 0;
		this.isPseudoLevel = false;

		this.init();
		this.addEventListener();


		this.log('Clusternav');
	}

	addEventListener() {
		window.addEventListener('load', (e) => {
			this.clusterArrowClick();
			this.clusterLinkClick(e);
			this.clusterLinkBackClick(e);
			if (document.querySelector('.back-link--main')) {
				this.clusterLinkBackToMainClick(e);
			}
		});
	}

	init() {
		// We are on a sublevel
		if (this.el.querySelector('.o-cluster-nav-mobile__active-link')) {
			this.setMenuHeight(this.el.querySelector('.o-cluster-nav-mobile__active-link').nextElementSibling.children.length);

			document.querySelector('.o-cluster-nav-mobile__active-link').nextElementSibling.classList.add('is-active');
			// Follow the logic and add --open class to previous level,
			// when we are on "active pseudoLevel"
			if (document.querySelector('.o-cluster-nav-mobile__active-link').closest('li').classList.contains('has-children')) {
				document.querySelector('.o-cluster-nav-mobile__active-link').closest('li').classList.add('has-children--open');
			}
			// More than one level down we need to go one level deeper: "active pseudoLevel"
			if (!document.querySelector('.o-cluster-nav-mobile__active-link').closest('li').classList.contains('o-cluster-nav-mobile__level-1')) {
				this.goToSpecificCluster(true);
			} else {
				this.goToSpecificCluster();
			}
		} else {
			// We are on an area page (Viden, Om os etc)
			this.goToSpecificCluster();
			if (this.isPseudoLevel === true) {
				this.setMenuHeight(this.el.querySelector('.has-children--open ul').children.length);
			}
		}
	}


	goToSpecificCluster(_moveOneMore) {
		const levels = this.el.querySelectorAll('.has-children--open');
		let _slidevalue = 0;
		// If we are in a level below main areapages this is true
		if (_moveOneMore === true) {
			this.isPseudoLevel = true;
			_slidevalue = 100;
		}
		levels.forEach(() => {
			_slidevalue += 100;
			document.querySelector('.o-cluster-nav-mobile').style.transform = 'translateX(-' + _slidevalue + '%)';
		});
		this.slideValue = _slidevalue;
	}

	clusterLinkClick() {
		const linkDisabled = document.querySelectorAll('.o-cluster-nav-mobile ul .has-children  a');
		linkDisabled.forEach((link) => {
			link.addEventListener('click', (e) => {
				if (e.target.tagName === 'SPAN') {
					e.preventDefault();
				}
			});
		});
	}

	clusterArrowClick() {
		const clusterToggle = document.querySelectorAll('.o-cluster-nav-mobile ul .has-children>a span');
		clusterToggle.forEach((span) => {
			span.addEventListener('click', (e) => {
				this.setMenuHeight(e.target.closest('a').nextElementSibling.children.length);
				e.target.closest('a').nextElementSibling.classList.toggle('js-isopen');// Open next
				e.target.closest('li').classList.add('has-children--open');// Open next
				e.target.closest('ul').classList.toggle('js-isopen');// Close previous
				document.querySelector('.o-cluster-nav-mobile').setAttribute('style', 'transform: translateX(' + (-this.slideValue - 100) + '%);');
				this.slideValue += 100;
				document.querySelector('.o-off-canvas__container').scrollTop = 0;
			});
		});
	}

	clusterLinkBackClick() {
		const backLink = document.querySelectorAll('.o-cluster-nav-mobile__back');
		backLink.forEach((link) => {
			link.addEventListener('click', (e) => {
				e.target.closest('ul').classList.remove('js-isopen');
				e.target.closest('ul').classList.remove('is-active');
				if (e.target.closest('li ul').closest('li').classList.contains('has-children--open')) {
					e.target.closest('.has-children').classList.toggle('has-children--open');// reset
				}
				document.querySelector('.o-cluster-nav-mobile').setAttribute('style', 'transform: translateX(' + (-this.slideValue + 100) + '%);');
				this.slideValue -= 100;
				this.setMenuHeight(e.target.closest('ul').parentNode.parentNode.children.length);
				e.preventDefault();
				// eslint-disable-next-line no-unused-expressions
				this.isSubisPseudoLevelpage === false;
			});
		});
	}

	clusterLinkBackToMainClick() {
		const backToMainLink = document.querySelector('.back-link--main');
		backToMainLink.addEventListener('click', (e) => {
			e.target.closest('nav > ul').classList.remove('js-isopen');
			e.target.closest('nav > ul').classList.remove('is-active');
			if (e.target.closest('li ul').closest('li').classList.contains('has-children--open')) {
				e.target.closest('.has-children').classList.toggle('has-children--open');// reset
			}
			document.querySelector('.o-cluster-nav-mobile').setAttribute('style', 'transform: translateX(' + (-this.slideValue + 200) + '%);');
			this.slideValue -= 200;
			this.setMenuHeight(e.target.closest('nav > ul').children.length);
			e.preventDefault();
			// eslint-disable-next-line no-unused-expressions
			this.isSubisPseudoLevelpage === false;
		});
	}

	setMenuHeight(listItems) {
		let menuHeight;
		let containerHeight = document.querySelector('[data-ref="off-canvas__container"]').clientHeight;
		let serviceMenuHeight = document.querySelector('.o-service-nav__list').clientHeight;
		const totalHeight = pxToRem(containerHeight + serviceMenuHeight);
		const reducedHeight = pxToRem(containerHeight - serviceMenuHeight);

		// Base case: If there are exactly 2 list items, set a fixed menu height of 10 rem
		if (listItems === 2) {
			menuHeight = 10; // rem
		}

		if (listItems > 2) {
			// Case 1: Large lists (more than 10 items)
			if (listItems > 10) {
				// Adjust menuHeight based on screen size:
				// - Subtract 3 rem for larger screens
				// - Add listItems count for smaller screens to avoid overflow
				menuHeight = containerHeight > 600 ? totalHeight - 3 : totalHeight + listItems;
			}
			// Case 2: Moderate large lists (7-10 items)
			else if (listItems > 6) {
				// Subtract the listItems count from totalHeight to save space
				menuHeight = totalHeight - listItems;
			}
			// Case 3: Smaller lists (3-6 items)
			else {
				// Adjust menuHeight based on screen size:
				// - Subtract (listItems * 3) rem for larger screens to ensure compact spacing
				// - Subtract listItems count directly for smaller screens
				menuHeight = containerHeight > 600 ? reducedHeight - (listItems * 3) : reducedHeight - listItems;
			}
		}

		const primaryNavItems = document.querySelectorAll('.o-primary-nav .m-nav-list__item .a-link') || document.querySelectorAll('.profile-tab');
		// eslint-disable-next-line no-unused-vars
		let primaryNavHasActive = false;
		for (let i = 0; i < primaryNavItems.length; i++) {
			if (primaryNavItems[i].classList.contains('a-link--active') || primaryNavItems[i].classList.contains('active-tab')) {
				primaryNavHasActive = true;
			}
		}

		// Only calculate service nav position if cluster mobile nav is present.
		window.setTimeout(() => {
			document.querySelector('.o-off-canvas .o-service-nav__list').style.marginTop = menuHeight + 'rem';
		}, 200);
	}
}

export default ClusternavMobile;
